import React from 'react';
import { ClosestDealersHeader } from './closestDealersHeader.js';
import { PlacesSearchBox } from './placesSearchBox.js';
import { ClosestDealersEntry } from './closestDealersEntry.js';

export class ClosestDealers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            entries: [],
            showNextButton: false,
            showPrevButton: false
        };

        this.start = null;
        this.end = 0;
        this.pageCounter = 0;

        this.translations = JSON.parse($("#translations").html());
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.closestDealers !== nextProps.closestDealers && nextProps.closestDealers.length) {
            this.start = null;
            this.end = 0;
            this.pageCounter = 0;
            this.getNextThreeDealers(nextProps.closestDealers);
        }
        if (!nextProps.closestDealers.length || nextProps.noDealersFound) {
            this.setState({
                entries: [],
                showNextButton: false,
                showPrevButton: false
            });
        }
    }

    render() {
        let nextButton = null;
        let prevButton = null;
        let pageCounter = null;
        let noDealersFound = null;

        if (this.state.showNextButton) {
            nextButton = <button className="closest-dealer-button btn btn-primary" id="next" onClick={this.getNextThreeDealers.bind(this, this.props.closestDealers)}> <span className="icon-arrow-right2"></span> </button>
        }
        if (this.state.showPrevButton){
            prevButton = <button className="closest-dealer-button btn btn-primary" id="prev" onClick={this.getPrevThreeDealers.bind(this, this.props.closestDealers)}> <span className="icon-arrow-left2"></span> </button>
        }
        if (this.state.entries.length) {
            pageCounter = <span id="closestDealerPageCounter">{this.pageCounter}</span>
        }
        if (this.props.noDealersFound) {
            noDealersFound = <div id="noDealersError" className="error">{this.translations.closestDealers.noResults}</div>
        }
        return (
            <div>
                <div id="dealersHeader">
                    <ClosestDealersHeader
                        translations={this.translations.closestDealers}
                    />
                </div>
                <div id="dealersContent">
                    <PlacesSearchBox
                        wrapperId={"small-search-wrapper"}
                        searchBoxId={"small-search-box"}
                        placeholder={this.translations.closestDealers.searchPlaceholder}
                        searchOriginAddress={this.props.searchOriginAddress}/>
                        {noDealersFound}
                    {this.state.entries}
                </div>
                {prevButton}
                {pageCounter}
                {nextButton}
            </div>
        );
    }

    getPrevThreeDealers(dealers){
        let entries = [];
        let showNextButton = true;
        this.pageCounter -= 1;
        let slicedDealers = this.slicePrevDealers(dealers);
        for (let i = 0; i < 3; i++) {
            let dealer = slicedDealers[i];
            entries.push(<ClosestDealersEntry
                key={dealer.Id}
                dealer={dealer}
                translations={this.translations.closestDealers}
                onDealerClick={this.props.onDealerClick}
            />);
        }
        if (this.start === 0) {
            this.setState({
                entries: entries,
                showPrevButton: false,
                showNextButton: showNextButton
            });
        } else {
            this.setState({
                entries: entries,
                showNextButton: showNextButton
            });
        }
    }

    getNextThreeDealers(dealers){
        let entries = [];
        let showNextButton = true;
        let showPrevButton = false;
        this.pageCounter += 1;
        let slicedDealers = this.sliceNextDealers(dealers);
        if (this.start > 0) {
            showPrevButton = true;
        }
        for (let i = 0; i < 3; i++) {
            let dealer = slicedDealers[i];
            if (dealer === undefined) {
                showNextButton = false;
                break;
            }
            entries.push(<ClosestDealersEntry
                key={dealer.Id}
                dealer={dealer}
                translations={this.translations.closestDealers}
                onDealerClick={this.props.onDealerClick}
            />);
        }

        if (dealers.length === this.end) {
            this.setState({
                entries: entries,
                showNextButton: false,
                showPrevButton: true
            });
        } else {
            this.setState({
                entries: entries,
                showNextButton: showNextButton,
                showPrevButton: showPrevButton
            });
        }
    }

    slicePrevDealers(dealers) {
        this.end = this.start;
        this.start -= 3;
        let slicedDealers = dealers.slice(this.start, this.end);
        return slicedDealers;
    }

    sliceNextDealers(dealers) {
        this.start = this.end;
        this.end += 3;
        let slicedDealers = dealers.slice(this.start, this.end);
        return slicedDealers;
    }
}